// src/context/ThemeContext.jsx
import React, { createContext, useState, useEffect, useContext } from "react";

// إنشاء الـ Context
const ThemeContext = createContext();

// الـ Provider لتغليف التطبيق وتوفير حالة الثيم
export const ThemeProvider = ({ children }) => {
  // جلب الثيم المحفوظ في localStorage أو الافتراضي "dark"
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark";
  });

  // تغيير كلاس الـ body عند تغير الثيم وحفظ التفضيل
  useEffect(() => {
    const body = document.body;

    if (theme === "light") {
      body.classList.add("light-mode");
      body.classList.remove("dark-mode");
    } else {
      body.classList.add("dark-mode");
      body.classList.remove("light-mode");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  // دالة لتبديل الثيم بين dark و light
  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Hook لاستخدام الثيم بسهولة في المكونات
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
